export default "__VITE_ASSET__CLHAzfJZ__"